import type React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  color: #257da2;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
  transition: 0.2s;
  &:hover,
  &:active,
  &:focus {
    color: #0c4861;
  }
`

interface Props {
  onClick: () => void
  children: React.ReactNode
}

const TertiaryAction = ({ onClick, ...props }: Props) => {
  return <Wrapper onClick={onClick}>{props.children}</Wrapper>
}
export default TertiaryAction
